import { render, staticRenderFns } from "./CruiseDetailsAlternativeProducts.vue?vue&type=template&id=3ac4c298&"
import script from "./CruiseDetailsAlternativeProducts.vue?vue&type=script&lang=js&"
export * from "./CruiseDetailsAlternativeProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports